import { Search, MoreDots } from 'blaze-ui/icons/20'
import Styles from './YouTubeShortPreview.module.scss'

export const TopActions = () => {
  return (
    <div className={Styles.topActions}>
      <Search />
      <div className={Styles.moreDots}>
        <MoreDots />
      </div>
    </div>
  )
}
